import { MetTheme } from '@mono/types/src/met-ui/index';

export const lightTheme: MetTheme = {
    background: '#fff',
    secondary: '#ECECEC',
    text: '#172344',
    icon: '#8B8B8B',
    iconSecondary: '#595959',
    hover: 'rgba(101, 141, 255, 0.2)',
    boxShadow: 'rgba(85, 91, 108, 0.3)',
    border: '#CDCDCD',
    hoverBorder: '#7599FF',
    contrast: '#000',
};
export const darkTheme: MetTheme = {
    background: '#23262F',
    secondary: '#383a43',
    text: '#FFFFFF',
    icon: '#909AB5',
    iconSecondary: 'rgba(255,255,255,0.8)',
    hover: 'rgba(101, 141, 255, 0.2)',
    boxShadow: 'rgba(0, 0, 0, 0.3)',
    border: 'rgba(255,255,255, 0.4)',
    hoverBorder: '#7599FF',
    contrast: '#fff',
};

export const themeSelector = (themeType?: string): MetTheme => {
    if (themeType === 'dark') {
        return darkTheme;
    } else if (themeType === 'light') {
        return lightTheme;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? darkTheme : lightTheme;
};
